import { create } from 'zustand';
import type { Props as ButtonProps } from '@ab-inbev-maz/compass/dist/entities/components/button.js';
import type { IconName } from '@ab-inbev-maz/compass/dist/entities/components/icon.js';

export type ModalIconType = 'success' | 'error' | 'warning' | 'info' | 'custom' | 'warning-octagon';

interface ModalAction extends ButtonProps {
  label: string;
  onClick: () => void;
}

interface ModalConfig {
  title?: string;
  message?: string | React.ReactNode;
  iconType?: ModalIconType;
  iconName?: IconName;
  customIconSvg?: React.ReactNode;
  primaryAction?: ModalAction;
  secondaryAction?: ModalAction;
  maxWidth?: string;
}

interface ModalState extends ModalConfig {
  isOpen: boolean;
  showModal: (config: ModalConfig) => void;
  hideModal: () => void;
}

const useModalStore = create<ModalState>((set) => ({
  isOpen: false,
  title: undefined,
  message: undefined,
  iconType: undefined,
  iconName: undefined,
  customIconSvg: undefined,
  primaryAction: undefined,
  secondaryAction: undefined,
  maxWidth: undefined,
  showModal: (config) =>
    set({
      isOpen: true,
      title: config.title,
      message: config.message,
      iconType: config.iconType,
      iconName: config.iconName,
      customIconSvg: config.customIconSvg,
      primaryAction: config.primaryAction,
      secondaryAction: config.secondaryAction,
      maxWidth: config.maxWidth,
    }),
  hideModal: () =>
    set({
      isOpen: false,
      title: undefined,
      message: undefined,
      iconType: undefined,
      iconName: undefined,
      customIconSvg: undefined,
      primaryAction: undefined,
      secondaryAction: undefined,
      maxWidth: undefined,
    }),
}));

export const { getState: getModalState, setState: setModalState, subscribe: subscribeModalState } = useModalStore;

export const showGlobalModal = (config: Parameters<ModalState['showModal']>[0]) => {
  useModalStore.getState().showModal(config);
};

export const hideGlobalModal = () => {
  useModalStore.getState().hideModal();
};

export default useModalStore;
